// Rails constants
export const MIN_AMOUNT_OF_PICS = 25
export const MIN_PRICE = 45.0
export const PER_ITEM_DIGITAL_PRICE = 1.35

// Other constants
export const MAX_AMOUNT_OF_PICS = 1000
export const USB_PRICE = 25
export const RETURN_ART_PRICE = 20
